import { render, staticRenderFns } from "./Earth.vue?vue&type=template&id=36bc4499&"
import script from "./Earth.vue?vue&type=script&lang=js&"
export * from "./Earth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports